import type {
  LiveQuoteRequest,
  LiveQuoteResponse,
  LiveTradeAmendRequest,
  LiveTradeCancelResponse,
  LiveTradeCreateRequest,
  LiveTradeResponse,
} from 'apiConnector/secondary-market/live/models';
import type { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import type { IHttpBody, IHttpClient } from 'utils/http/httpClient.model';

export interface LiveQuoteApi {
  requestQuote(request: LiveQuoteRequest): Observable<LiveQuoteResponse>;
  requestTrade(request: LiveTradeCreateRequest): Observable<LiveTradeResponse>;

  amendTrade(etag: string, request: LiveTradeAmendRequest): Observable<LiveTradeResponse>;
  cancelTrade(orderId: string): Observable<LiveTradeCancelResponse>;
  bookTrade(orderId: string): Observable<{}>;
  cancelQuote(quoteId: string): Observable<{ status: string }>;
}
export function liveQuoteTradeApiConnector(httpClient: IHttpClient): LiveQuoteApi {
  return {
    requestQuote: req => {
      return httpClient
        .postJSON<LiveQuoteResponse>({
          url: 'api/v1/secondary-market/live-trade/quote',
          body: req as IHttpBody,
          tryParseErrorPayload: true,
          timeOut: 15_000,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    requestTrade: req => {
      return httpClient
        .postJSON<LiveTradeResponse>({
          url: 'api/v1/secondary-market/live-trade/trade',
          body: req as IHttpBody,
          timeOut: 10_000,
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    cancelTrade: orderId => {
      return httpClient
        .patch<LiveTradeCancelResponse>({
          url: 'api/v1/secondary-market/live-trade/cancel',
          body: {
            orderId: orderId,
          },
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    bookTrade: orderId => {
      return httpClient
        .patch<{}>({
          url: `api/v1/secondary-market/live-trade/book`,
          body: {
            orderId: orderId,
          },
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    cancelQuote: quoteId => {
      return httpClient
        .patch<{ status: string }>({
          url: 'api/v1/secondary-market/live-trade/quote/cancel',
          body: {
            quoteId: quoteId,
          },
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    amendTrade: (etag, req) => {
      return httpClient
        .patch<LiveTradeResponse>({
          url: `api/v1/secondary-market/live-trade/amend?etag=${encodeURIComponent(etag)}`,
          body: req as IHttpBody,
          timeOut: 10_000,
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
